import { CommonModule } from '@angular/common';
import { Component, computed, Input, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';
import { switchMap, tap } from 'rxjs/operators';
import { CategoryInterface } from '@vendasta/category';
import { CategoryService } from '../../../shared-services/category.service';

@Component({
  selector: 'crm-categories-filter-chip',
  template: `
    @if (isLoading() && selectedCategoryIds().length > 0) {
      <div class="stencil-shimmer"></div>
    } @else {
      {{ selectedCategoriesText() }}
    }
  `,
  providers: [],
  styleUrls: ['./categories-filter-chip.component.scss'],
  imports: [CommonModule, TranslateModule],
})
export class CategoriesFilterChipComponent implements GalaxyAbstractFilterChip {
  selectedCategoryIds = signal<string[]>([]);
  selectedCategories = signal<CategoryInterface[]>([]);
  isLoading = signal(true);
  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    this.selectedCategoryIds.set(value?.map((v) => v.string || '') || []);
  }

  selectedCategoriesText = computed(() => {
    if (this.selectedCategories().length === 0) {
      return '';
    }
    const firstCategoryName = this.selectedCategories()[0].name || this.selectedCategoryIds()[0];
    if (this.selectedCategories().length === 1) {
      return firstCategoryName;
    }
    return `${firstCategoryName} +${this.selectedCategories().length - 1}`;
  });

  constructor(private readonly categoryService: CategoryService) {
    toObservable(this.selectedCategoryIds)
      .pipe(
        switchMap((categoryIds) => {
          this.isLoading.set(true);
          return this.categoryService.getMultiCategories(categoryIds);
        }),
        tap(() => {
          this.isLoading.set(false);
        }),
        takeUntilDestroyed(),
      )
      .subscribe((result) => {
        this.selectedCategories.set(result);
      });
  }
}
